import { hasPermission } from '@blimo/shared';

/** Tabs of the property detail page (docs/frontend/admin.md §3). `disabled` = not implemented yet („folgt“). */
export const PROPERTY_TABS = [
  { id: 'uebersicht', label: 'Übersicht' },
  { id: 'einheiten', label: 'Einheiten', permission: 'units.view' },
  { id: 'eigentuemer', label: 'Eigentümer', permission: 'ownerships.view' },
  { id: 'mieter', label: 'Mieter', permission: 'tenancies.view' },
  { id: 'finanzen', label: 'Finanzen', permission: 'finance.view' },
  { id: 'dokumente', label: 'Dokumente', permission: 'documents.view' },
  { id: 'zaehler', label: 'Zähler', permission: 'meters.view' },
  { id: 'belegpruefungen', label: 'Belegprüfungen', permission: 'document-checks.view' },
  { id: 'kommunikation', label: 'Kommunikation', anyPermission: ['announcements.view', 'messages.view', 'proxy-authorizations.view'] },
  { id: 'historie', label: 'Historie', permission: 'audit-log.view' },
];

/** Tab sichtbar? `permission` = genau dieses Recht, `anyPermission` = mindestens eines davon. */
export function tabAllowed(me, tab) {
  if (tab.permission) return hasPermission(me, tab.permission);
  if (tab.anyPermission) return tab.anyPermission.some((p) => hasPermission(me, p));
  return true;
}
